import { makeTableFromArray, makeTableFromObject } from './MakeVerticalTable';
const checkValueTypeVerticalTable = (value, showDataType) => {
  return typeof value === 'object'
    ? makeTableFromObject(value, showDataType)
    : Array?.isArray(value)
    ? makeTableFromArray(value, showDataType)
    : typeof value === 'boolean'
    ? value.toString()
    : value;
};
export default checkValueTypeVerticalTable;
